/* 🔴 QUEUE N2b → N2b-2 — PRINTING IS SCOPED BY ONE BODY CLASS. The printed workout (`WorkoutPrintSheet`) is mounted beside
 * the app, `body.is-printing` tells `pro.css`'s `@media print` block (LAST in the sheet) to print it and nothing else, and both
 * come away on `afterprint` — which every engine fires after its dialog closes, printed or cancelled. ⌘P on any other page
 * prints as before. (N2b's week print scoped the Extended view itself; N2b-2 prints the grid instead, from one model.) */

export const PRINTING = "is-printing";

export function printScoped(
  mount: () => () => void,
  doc: Pick<Document, "body"> = document,
  win: Pick<Window, "addEventListener" | "removeEventListener" | "print"> = window,
): void {
  const unmount = mount();
  doc.body.classList.add(PRINTING);
  const done = (): void => {
    doc.body.classList.remove(PRINTING);
    unmount();
    win.removeEventListener("afterprint", done);
  };
  win.addEventListener("afterprint", done);
  win.print();
}
